import { Button } from 'react-bootstrap';
import { FaWhatsapp } from 'react-icons/fa6';
import { FaInfoCircle } from 'react-icons/fa';
import { handleWhatsApp } from '../../utils/productUtils';

const VariationAvailabilityNotice = ({
    product,
    variationType,
    selectedVariation,
    title,
    description,
    cardClassName = '',
    buttonClassName = '',
}) => (
    <div className="variation-availability-notice">
        <div className={`variation-availability-card ${cardClassName}`}>
            <div className="variation-availability-content">
                <div className="variation-availability-header d-flex align-items-center gap-2 fw-bold">
                    <FaInfoCircle className="variation-availability-icon" />
                    <span className="variation-availability-title">{title || `Confirma ${variationType}`}</span>
                </div>
                <p className="mb-0 variation-availability-copy">{description}</p>
            </div>
            <div className="variation-availability-action">
                <Button
                    variant="warning"
                    size="sm"
                    className={`variation-availability-btn rounded-pill ${buttonClassName}`.trim()}
                    onClick={() =>
                        handleWhatsApp(product, 'availability', {
                            [variationType]: selectedVariation,
                        })
                    }
                >
                    <FaWhatsapp size={16} className="me-1" />
                    Consultar por WhatsApp
                </Button>
            </div>
        </div>
    </div>
);

export default VariationAvailabilityNotice;

